import React from "react";
import { CModal, CModalHeader, CModalTitle, CModalBody } from "@coreui/react";
import DocumentVerification from "../../models/document-verification";
import Asset from "../../models/asset";
import DocumentVerificationCopyForm from "./DocumentVerificationCopyForm";

interface DocumentVerificationCopyModalProps {
  verification?: DocumentVerification;
  assets: Asset[];
  onClose: () => void;
  onSuccess: () => void;
}

const DocumentVerificationCopyModal: React.FC<
  DocumentVerificationCopyModalProps
> = ({ verification, assets, onClose, onSuccess }) => {
  const handleSuccess = () => {
    onSuccess();
    onClose();
  };

  return (
    <CModal show={true} onClose={onClose} size="xl" centered>
      <CModalHeader closeButton>
        <CModalTitle>Copiar Verificación de Documentos</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <DocumentVerificationCopyForm
          initialVerification={verification}
          onCancel={onClose}
          onSuccess={handleSuccess}
        />
      </CModalBody>
    </CModal>
  );
};

export default DocumentVerificationCopyModal;
